import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { FALLBACK_CONTENT } from "@/lib/data";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import ServicesGrid from "@/components/ServicesGrid";
import GallerySection from "@/components/GallerySection";
import WhyUs from "@/components/WhyUs";
import ReviewsSection from "@/components/ReviewsSection";
import AreasSection from "@/components/AreasSection";
import BookingForm from "@/components/BookingForm";
import ContactSection from "@/components/ContactSection";
import FaqSection from "@/components/FaqSection";
import Footer from "@/components/Footer";
import StickyBar from "@/components/StickyBar";
import CookieBanner from "@/components/CookieBanner";
import WhatsAppFloat from "@/components/WhatsAppFloat";

export default function HomePage() {
  const [content, setContent] = useState(FALLBACK_CONTENT);
  const [services, setServices] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [reviews, setReviews] = useState([]);

  const loadReviews = () => api.get("/reviews").then((r) => setReviews(r.data)).catch(() => {});

  useEffect(() => {
    api.get("/content").then((r) => setContent((c) => ({ ...c, ...r.data }))).catch(() => {});
    api.get("/services").then((r) => setServices(r.data)).catch(() => {});
    api.get("/gallery").then((r) => setGallery(r.data)).catch(() => {});
    loadReviews();
  }, []);

  return (
    <div className="bg-[#070b12] min-h-screen" data-testid="home-page">
      <Navbar content={content} />
      <Hero content={content} />
      <Marquee />
      <ServicesGrid services={services} />
      <GallerySection items={gallery} />
      <WhyUs />
      <ReviewsSection reviews={reviews} onSubmitted={loadReviews} />
      <AreasSection content={content} />
      <BookingForm services={services} content={content} />
      <ContactSection />
      <FaqSection />
      <Footer content={content} />
      <StickyBar content={content} />
      <WhatsAppFloat content={content} />
      <CookieBanner />
      <div className="h-[calc(4.25rem+env(safe-area-inset-bottom))] md:hidden" /> {/* spacer for sticky bar */}
    </div>
  );
}
